import {DropdownSelectInline} from 'shells/select-inline/dropdown-select-inline';

import {appHistory} from '../../../../../history';
import {useGetIndustries} from '../../../../core/select/hooks/use-get-industries';
import {DataFieldWrapper} from '../../../../core-entity/widgets/summary-widget/data-field-wrapper';

interface Props {
    industryId: string | null | undefined;
    onUpdateAccountIndustry: (industryId: string | null, industryName: string | null) => void;
    canAccessSetup: boolean;
}

export function AccountIndustryField(props: Props) {
    const {industries} = useGetIndustries();

    const selectedIndustry = props.industryId
        ? industries.find((industry) => industry.id === props.industryId)
        : undefined;

    return (
        <DataFieldWrapper
            label='Industry'
            children={
                <DropdownSelectInline
                    options={industries}
                    selectedValue={selectedIndustry}
                    selectedValueAlignment='left'
                    onChange={(selected) => {
                        props.onUpdateAccountIndustry(
                            selected ? selected.id : null,
                            selected ? selected.name : null
                        );
                    }}
                    onClear={() => {
                        props.onUpdateAccountIndustry(null, null);
                    }}
                    footerButton={
                        props.canAccessSetup && {
                            label: 'Manage industries',
                            onClick: () => {
                                appHistory.push('/setup/industry');
                            },
                        }
                    }
                />
            }
        />
    );
}
